import { CustomerExistsException } from '@scalefast/core';
import AUTH_EXCEPTIONS from '../../../Shared/Infrastructure/Exception/APIv4AuthExceptionMap';
import CREDENTIALS_EXCEPTIONS from '../../../Shared/Infrastructure/Exception/CredentialsExceptionMap';
const CUSTOMER_EXCEPTIONS = [{
  errorCode: '-700',
  exception: new CustomerExistsException()
}, ...AUTH_EXCEPTIONS, ...CREDENTIALS_EXCEPTIONS];
export default CUSTOMER_EXCEPTIONS;
